(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyDeleteController',BillingFrequencyDeleteController);

    BillingFrequencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'BillingFrequency'];

    function BillingFrequencyDeleteController($uibModalInstance, entity, BillingFrequency) {
        var vm = this;

        vm.billingFrequency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BillingFrequency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
